import React from "react"
import { graphql } from "gatsby"

import Layout from "../components/layout"
import TitleImage from "../components/titleImage"
import SEO from "../components/seo"
import './design.less';
import './home.less';
import Navigation from "../components/navigation";

const IndexPage = ({ data }) => (
  <Layout>
    <SEO title="Willkommen" keywords={[`gatsby`, `application`, `react`]} />
    <TitleImage imageData={data.titleImage} />
    <Navigation />
    <div className="page-content home">
      <div className="home-main"
        dangerouslySetInnerHTML={{ __html: data.content.edges.find(n => n.node.frontmatter.title === 'Startseite').node.html }}>
      </div>
      <div className="home-sidebar"
        dangerouslySetInnerHTML={{ __html: data.content.edges.find(n => n.node.frontmatter.title === 'Seitenleiste').node.html }}>
      </div>
    </div>
  </Layout>
)

export const pageQuery = graphql`
  query {
    content: allMarkdownRemark(
      filter: { frontmatter:{title: {in:["Startseite","Seitenleiste"]} } }
    ) {
      edges {
        node {
          frontmatter { title }
          html
        }
      }
    }

    titleImage: file(relativePath: { eq: "title.jpg" }) {
        childImageSharp {
          fluid(maxWidth: 1000, quality: 90) {
            ...GatsbyImageSharpFluid
          }
        }
      }
  }
`
export default IndexPage
